import type { KrpPlayer } from '@types';

const store: { player: KrpPlayer | null } = {
  player: null,
};

export const MainPlayer = {
  register: (player: KrpPlayer) => {
    store.player = player;
  },
  get: () => {
    return store.player;
  },
  remove: () => {
    store.player?.removePlayer();
    store.player = null;
  },
};
